const COOKIE_NAME = 'rab_app_login'

// Parent-Domain (z. B. beckenrocker.de), damit die öffentliche Website den App-Login erkennen kann
const getCookieDomain = () => {
  const parts = window.location.hostname.split('.')

  if (parts.length < 3 || /^\d+$/.test(parts[parts.length - 1])) {
    return ''
  }

  return `; domain=.${parts.slice(-2).join('.')}`
}

export const setLoginCookie = (loggedIn: boolean) => {
  const maxAge = loggedIn ? 60 * 60 * 24 * 365 : 0

  document.cookie = `${COOKIE_NAME}=${loggedIn ? '1' : ''}; path=/; max-age=${maxAge}; samesite=lax; secure${getCookieDomain()}`
}

export const syncLoginCookie = () => {
  setLoginCookie(Boolean(localStorage.getItem('token')))
}
